<script setup lang="ts">
import { GoogleMap, Marker } from 'vue3-google-map'
import type { Dealer } from '~/types/dealer.type'
import marker from '~/assets/images/dealers/marker.svg'

const { dealer } = defineProps<{
  dealer: Dealer
}>()
const config = useRuntimeConfig()
const api = ref(config.public.googleMapsApiKey)
const markerOptions = ref(
  {
    position: { lat: Number(dealer?.lat), lng: Number(dealer?.lng) },
    title: dealer?.title,
    animation: 'DROP',
    icon: marker,
  },
)
</script>

<template>
  <GoogleMap
    :api-key="api"
    :center="{ lat: Number(dealer?.lat), lng: Number(dealer?.lng) }"
    class="z-0 rounded-lg"
    :disable-default-ui="true"
    style="width: 100%; height: 100%"
    :zoom="15"
  >
    <Marker :options="markerOptions" />
  </GoogleMap>
</template>
